import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { ProfileInfo } from './profile-info.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProfileService {

    private profileInfoUrl = 'api/profile-info';

    constructor(private http: HttpClient) { }

    getProfileInfo(): Observable<ProfileInfo> {
        return this.http.get(this.profileInfoUrl)
            .map((res: ProfileInfo) => {
                let pi = new ProfileInfo();
                pi.activeProfiles = res.activeProfiles;
                pi.ribbonEnv = res.ribbonEnv;
                pi.inProduction = res.activeProfiles.indexOf('prod') !== -1;
                pi.swaggerEnabled = res.activeProfiles.indexOf('swagger') !== -1;
                return pi;
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/profiles/profile.service.ts